"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var PaginatorWrapper = function PaginatorWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "selectedPage", _descriptor, _this);
      _initializerDefineProperty(_this, "showSpinner", _descriptor2, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "derivedPage",
      get: function get() {
        var _this$props$store;
        return (0, _utils.isPresent)(this.props.currentPage) ? this.props.currentPage : (_this$props$store = this.props.store) === null || _this$props$store === void 0 ? void 0 : _this$props$store.page;
      }
    }, {
      key: "selectedPageIsNotSubmitted",
      get: function get() {
        return (0, _utils.isPresent)(this.selectedPage) && this.derivedPage !== this.selectedPage;
      }
    }, {
      key: "page",
      get: function get() {
        return this.selectedPage === null ? this.props.currentPage || this.derivedPage : this.selectedPage;
      }
    }, {
      key: "isLastPage",
      get: function get() {
        if (this.pagesCount && this.derivedPage) {
          return this.derivedPage === this.pagesCount;
        }
        if (this.props.store) {
          return !this.props.store.hasIndexData || this.props.store.indexData.length < this.props.store.limit;
        }
      }
    }, {
      key: "isFirstPage",
      get: function get() {
        return parseInt(this.derivedPage, 10) === 1;
      }
    }, {
      key: "totalCount",
      get: function get() {
        return this.props.totalCount || this.props.store.totalCount;
      }
    }, {
      key: "pagesCount",
      get: function get() {
        var _this$props$store2;
        if ((0, _utils.isPresent)(this.totalCount) || ((_this$props$store2 = this.props.store) === null || _this$props$store2 === void 0 ? void 0 : _this$props$store2.pagesCount) > 0) {
          return this.totalCount ? Math.ceil(this.totalCount / (this.props.limit || this.props.store.limit)) : this.props.store.pagesCount;
        }
      }
    }, {
      key: "afterIncrementPage",
      value: function afterIncrementPage(resp) {
        this.showSpinner = false;
        if (this.props.store) {
          this.props.store.afterGetIndex(resp);
        }
        if (this.props.onClickScrollToTop && !_state.AppUI.layout.isNative) {
          _state.AppUI.scrollToPageTop('smooth', this.props.pageTop);
        }
      }
    }, {
      key: "onPageIncremented",
      value: function onPageIncremented(increment) {
        if (this.props.withSpinner) {
          this.showSpinner = true;
        }
        if (this.props.onPagination) {
          this.props.onPagination(increment);
          if (this.props.onClickScrollToTop && !_state.AppUI.layout.isNative) {
            _state.AppUI.scrollToPageTop('smooth', this.props.pageTop);
          }
        }
        this.selectedPage = null;
        var nextPage = parseInt(this.derivedPage, 10) + increment;
        if (this.props.updateUrl) {
          this.setUrl(nextPage);
        }
        if ((0, _utils.isPresent)(this.props.store) && (!this.totalCount || nextPage <= this.pagesCount) && (!this.props.maxPage || nextPage <= this.props.maxPage) && increment === 1 && !this.isLastPage || increment === -1 && !this.isFirstPage) {
          var _this$props$store3;
          if (this.props.clearOnPagination) {
            this.props.store.resetIndexDataArray();
          }
          (_this$props$store3 = this.props.store) === null || _this$props$store3 === void 0 || _this$props$store3.incrementPage(increment, {
            ids: this.props.ids,
            queryStrings: this.props.queryStrings,
            filters: this.props.filters,
            callback: this.afterIncrementPage
          });
        }
      }
    }, {
      key: "onSetPage",
      value: function onSetPage(value) {
        this.selectedPage = value;
      }
    }, {
      key: "onSubmitPage",
      value: function onSubmitPage() {
        var updatedPage = parseInt(this.selectedPage, 10);
        if (this.props.withSpinner) {
          this.showSpinner = true;
        }
        if (this.props.updateUrl) {
          this.setUrl(updatedPage);
        }
        if (updatedPage > 0 && updatedPage <= this.pagesCount && this.props.store) {
          this.props.store.setPage(updatedPage);
          this.props.store.reloadIndexFiltered({
            ids: this.props.ids,
            queryStrings: this.props.queryStrings,
            filters: this.props.filters,
            callback: this.afterIncrementPage
          });
        }
      }
    }, {
      key: "setUrl",
      value: function setUrl(page) {
        var url = window.location.href;
        var ary = url.split('/page/');
        var newUrl = "".concat(ary[0], "/page/").concat(page);
        _state.AppUI.routeStore.updateUrl(newUrl);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onPageIncremented: this.onPageIncremented,
          onSetPage: this.onSetPage,
          setUrl: this.setUrl,
          page: this.page,
          isLastPage: this.isLastPage,
          isFirstPage: this.isFirstPage,
          selectedPageIsNotSubmitted: this.selectedPageIsNotSubmitted,
          onSubmitPage: this.onSubmitPage,
          totalCount: this.totalCount,
          pagesCount: this.pagesCount,
          derivedPage: this.derivedPage,
          showSpinner: this.showSpinner
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedPage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "derivedPage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "derivedPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedPageIsNotSubmitted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedPageIsNotSubmitted"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "page", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "page"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isLastPage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isLastPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isFirstPage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isFirstPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "totalCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "totalCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pagesCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pagesCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterIncrementPage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterIncrementPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onPageIncremented", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onPageIncremented"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetPage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSubmitPage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSubmitPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setUrl", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setUrl"), _class2.prototype), _class2)) || _class;
};
PaginatorWrapper.displayName = 'PaginatorWrapper';
var _default = exports["default"] = PaginatorWrapper;